import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

const TranslationTooltip = ({
  word,
  translation,
  loading,
  alreadyInVocabulary,
  onSave,
  saving,
  onClose,
  position,
}) => {
  const tooltipRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (tooltipRef.current && !tooltipRef.current.contains(e.target)) {
        onClose();
      }
    };
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEsc);
    };
  }, [onClose]);

  const content = (
    <div
      ref={tooltipRef}
      style={{
        position: 'fixed',
        top: position.top,
        left: position.left,
        transform: 'translateX(-50%)',
        minWidth: '160px',
        maxWidth: '260px',
        zIndex: 9999,
        backgroundColor: 'white',
        borderRadius: '10px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        border: '1px solid #e5e7eb',
        padding: '10px 12px',
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Arrow */}
      <div
        style={{
          position: 'absolute',
          top: '-7px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 0,
          height: 0,
          borderLeft: '7px solid transparent',
          borderRight: '7px solid transparent',
          borderBottom: '7px solid white',
          filter: 'drop-shadow(0 -1px 0 #e5e7eb)',
        }}
      />

      {/* Word */}
      <div style={{ fontWeight: 600, color: '#1f2937', fontSize: '13px', marginBottom: '4px' }}>
        {word}
      </div>

      {/* Translation or loading */}
      {loading ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#6b7280', fontSize: '13px' }}>
          <span
            style={{
              width: '12px',
              height: '12px',
              border: '2px solid #3b82f6',
              borderTopColor: 'transparent',
              borderRadius: '50%',
              display: 'inline-block',
              animation: 'spin 0.7s linear infinite',
            }}
          />
          Překládám...
        </div>
      ) : (
        <div style={{ color: '#2563eb', fontWeight: 500, fontSize: '15px', marginBottom: '8px' }}>
          {translation}
        </div>
      )}

      {/* Save button */}
      {!loading && translation && translation !== 'Chyba překladu' && (
        alreadyInVocabulary ? (
          <div style={{ color: '#16a34a', fontSize: '12px', fontWeight: 500 }}>
            ✓ Uloženo ve slovníku
          </div>
        ) : (
          <button
            onClick={(e) => { e.stopPropagation(); onSave(); }}
            disabled={saving}
            style={{
              width: '100%',
              padding: '5px 10px',
              backgroundColor: saving ? '#93c5fd' : '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '12px',
              fontWeight: 500,
              cursor: saving ? 'default' : 'pointer',
              transition: 'background-color 0.15s',
            }}
          >
            {saving ? 'Ukládám...' : '+ Uložit do slovníku'}
          </button>
        )
      )}

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );

  return createPortal(content, document.body);
};

export default TranslationTooltip;
